import { render, staticRenderFns } from "./SideBarFooter.vue?vue&type=template&id=2dd37b46&"
import script from "./SideBarFooter.vue?vue&type=script&lang=js&"
export * from "./SideBarFooter.vue?vue&type=script&lang=js&"
import style0 from "./SideBarFooter.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports